/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

export const inlineSuggestCommitId = 'editor.action.inlineSuggest.commit';

export const showPreviousInlineSuggestionActionId = 'editor.action.inlineSuggest.showPrevious';

export const showNextInlineSuggestionActionId = 'editor.action.inlineSuggest.showNext';
